<!-- Classy Layout (Student default) -->
@if (layout === 'classy') {
    <classy-layout></classy-layout>
}

<!-- Empty Layout (Auth pages) -->
@if (layout === 'empty') {
    <empty-layout></empty-layout>
}
